var p2s = /,?([a-z]),?/gi;
export default function parsePathArray(path) {
    return path.join(',').replace(p2s, '$1');
}
//# sourceMappingURL=parse-path-array.js.map